<template>
  <div class="pwa-app">
    <div v-if="displayIosInstallToHomeScreen" class="ios-banner">
      <IOSInstallBanner @close-banner="closeBanner" />
    </div>
    <EulaAcceptance v-if="isEulaFeatureEnabled && isClientRole" />
    <CaModal id="modalCustom" :opened="$store.state.sendFilesDone">
      <div slot="title">
        <h5 class="ev-modal__title">Importation du document</h5>
      </div>
      <template slot="body">
        <div class="ev-modal__body">
          <p> Votre document a été envoyé avec succès </p>
        </div>
      </template>
      <template slot="footer">
        <div class="text-center" />
      </template>
    </CaModal>
    <CaModal id="modalCustom" :opened="$store.state.sendFilesDone">
      <div slot="title">
        <h5 class="ev-modal__title">Importation du document</h5>
      </div>
      <template slot="body">
        <div class="ev-modal__body">
          <p> Votre document a été envoyé avec succès </p>
        </div>
      </template>
      <template slot="footer">
        <div class="text-center" />
      </template>
    </CaModal>
    <div v-if="displayBandeauMarketing" id="top-banner">
      <BandeauMarketing />
    </div>
    <div class="main-content"
         :class="{ 'additional-margin': displayIosInstallToHomeScreen }">
      <template v-if="sessionHasDossier || $route.name === 'login'">
        <Swipe :transition-name="transitionName">
          <router-view class="page" :transition-name="transitionName" />
        </Swipe>
        <Menu v-if="$route.name !== 'login'" />
        <PhotoFloatingButtonMenu v-if="showPhotoFloatingButtonMenu" />
      </template>
      <template v-else>
        <DossierErreur />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import apis from '@/apis';
import DossierErreur from '@/components/shared-module-components/Erreur/DossierErreur.vue';
import Menu from '@/modules/pwa/Components/Menu.vue';
import Swipe from '@/modules/pwa/Components/Swipe.vue';
import PhotoFloatingButtonMenu from '@/modules/pwa/Components/PhotoFloatingButtonMenu.vue';
import IOSInstallBanner from '@/modules/pwa/Components/IOSInstallBanner.vue';
import CaModal from '@/components/molecules/CaModal.vue';
import EulaAcceptance from '@/modules/pwa/Pages/Eula/EulaAcceptance.vue';

export default {
  name: 'App',
  components: {
    EulaAcceptance,
    DossierErreur,
    Menu,
    Swipe,
    PhotoFloatingButtonMenu,
    IOSInstallBanner,
    CaModal,
  },
  data() {
    return {
      sessionHasDossier: false,
      transitionName: 'swipe-left',
      displayIosInstallToHomeScreen: false,
      userConnected: null,
      isClientRole: false,
      clientRoleId: 3,
      isEulaFeatureEnabled: false,
    };
  },
  computed: {
    ...mapState(['featureFlags']),
    showPhotoFloatingButtonMenu() {
      return !['login', 'Page-Compte', 'Tab-Marketplace', 'Show-Partner-Pwa'].includes(this.$route.name);
    },
    ...mapState('sendFilesDone'),
  },
  watch: {
    $route(to, from) {
      this.determineTransitionDirection(to, from);
    },
  },
  mounted() {
    document.addEventListener('install', () => {
      this.displayIosInstallToHomeScreen = false;
      localStorage.setItem('is-pwa-installed', true);
    });
  },
  created() {
    (async () => {
      await this.setSessionStatus();
    })();
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod|safari\/604|safari\/605/.test(userAgent);
    };
    const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
    if (isIos() && !isInStandaloneMode() && localStorage.getItem('is-pwa-installed') !== true) {
      this.displayIosInstallToHomeScreen = true;
    }
    apis.User.getUser().then((response) => {
      this.userConnected = response.data;
      if (this.userConnected.created_at < '2020-11-01' && !this.isPwaBannerChangeClosed) {
        this.displayChangeFolderBanner = true;
      }
      if (this.userConnected.roles.length > 0) {
        const clientRole = this.userConnected.roles.find((role) => role.id === this.clientRoleId);
        if (clientRole) {
          this.isClientRole = true;
        }
      }
    });
    this.isEulaFeatureEnabled = this.featureFlags?.isEulaFeatureEnabled;
  },
  methods: {
    async setSessionStatus() {
      const { data } = await apis.User.sessionStatus();
      this.sessionHasDossier = data.hasDossier;
    },
    determineTransitionDirection(to, from) {
      if (to.name && from.name) {
        let orderFrom = from.matched
          .filter((match) => Object.keys(match.meta).includes('order') && match.name === from.name);

        let orderTo = to.matched
          .filter((match) => Object.keys(match.meta).includes('order') && match.name === to.name);

        if (orderTo.find((match) => match.meta) && orderFrom.find((match) => match.meta)) {
          orderFrom = orderFrom[orderFrom.length - 1].meta.order;
          orderTo = orderTo[orderTo.length - 1].meta.order;

          if (orderFrom > orderTo) {
            this.transitionName = 'swipe-right';
          } else {
            this.transitionName = 'swipe-left';
          }
        }
      }
    },
    closeBanner() {
      this.displayIosInstallToHomeScreen = false;
    },
  },
};
</script>

<style lang="scss">
@import 'src/scss/mixins/scroll';

html,
body {
  width: 100%;
  height: 100%;
  background: $varient-background-color;
  margin: 0;
  padding: 0;
  @include scroll('tiny', $varient-background-color);
}

#modalCustom i.even-icon-close.transparency-modal-icon {
  visibility: hidden;
}

#modalCustom .ev-modal__header-actions {
  height: 80px;
}

#modalCustom .ev-modal__footer {
  display: none;
}

#modalCustom .ev-modal__body {
  padding: 25px 0px;
  font-weight: $font-weight-medium;
  font-size: 0.95rem;
}

.additional-margin {
  margin-top: 70px;
}

.pwa-app {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  .page {
    width: 100vw;
    height: 100vh;
  }

  .main-content {
    width: 100vw;
    height: calc(100vh - 10px);
  }
}

.ev-banner {
  width: 100%;
  height: 70px;
  border-bottom: 1px solid $menu-font-color;
  background-image: url(/assets/img/background-tab-ancien-espace.png);
  padding: 8px;
  z-index: 5;
  position: fixed;
}

.ev-banner-content {
  font-weight: $font-weight-medium;
}
</style>
